import React from 'react'
import { ScrollView } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { XStack } from '@zet/design-system'
import LeadHeaderCard from '@zet/feature-leads/components/leadHeaderCard'
import useLeadFilterStore from '@zet/feature-leads/store/leadFilter'
import { QuickFilter } from '@zet/utils/Constants'

import { useLeadCount } from '../../api/leads/hooks'
import { leadSummary } from '../../utils/constants'
import LeadSummaryLoader from './leadSummaryLoader'

type LeadsSummaryProps = {
  refetch: () => void
}
const LeadsSummary = ({ refetch }: LeadsSummaryProps) => {
  const { data: leadsData, isLoading } = useLeadCount()
  const leadFilterStore = useLeadFilterStore()

  const refetchLeads = (leads: string[], eventName: string) => {
    publishEvent('click_action', { item_name: eventName })
    leadFilterStore.updateFilter({
      profileStatus: leads,
    })
    QuickFilter['profileStatus'].value = leads
    refetch()
  }

  if (isLoading) {
    return <LeadSummaryLoader />
  }

  return (
    <XStack className="bg-tertiary-80 border-tertiary-20 mx-3 mb-2 rounded border">
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        {leadSummary?.map((lead, index) => {
          return (
            <LeadHeaderCard
              key={index}
              icon={lead?.icon}
              leadTitle={lead?.title}
              leadCount={leadsData?.[lead.type]}
              onPress={() => refetchLeads(lead?.keys, lead?.eventName)}
            />
          )
        })}
      </ScrollView>
    </XStack>
  )
}
export default LeadsSummary
